import { gql } from '@apollo/client'

export default gql`
  mutation sendOnboardingEmail($id: ID!, $recipient: String!) {
    sendOnboardingEmail(id: $id, recipient: $recipient) {
      id
    }
  }
`
